import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import DownloadTable from 'components/download-table';

import './style.css';

import columns, { subColumns } from './columns';

const expandedRowRender = (record) => {
  return (
    <Table columns={subColumns} dataSource={[record]} pagination={false} />
  );
};

const WorkersWidget = ({ users }) => {
  const data = users.filter((user) => user.info.role === 'isWorker');
  return (
    <section className="admin-panel-section">
      <header className="admin-panel-header">
        <h2>Workers</h2>
        <DownloadTable
          data={data}
          columns={[...columns, ...subColumns]}
          name="workers"
        />
      </header>
      <Table
        dataSource={data}
        columns={columns}
        expandable={{ expandedRowRender }}
      />
    </section>
  );
};

WorkersWidget.propTypes = {
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    })
  ).isRequired,
};

export default WorkersWidget;
